<template>
  <div id="app">
    <qgov-header />

    <div class="container-fluid qg-site-width">
      <div id="qg-content">
        <div id="qg-three-col" class="row">
          <div id="qg-primary-content" role="main">
            <router-view />
          </div>
          <aside id="qg-secondary-content">
            <qgov-right-aside />
          </aside>
          <qgov-leftnav />
        </div>        
      </div>
    </div>

    <qgov-footer />
  </div>
</template>

<script>
import TheLeftNav from "@/components/TheLeftNav.vue";
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import TheRightAside from "@/components/TheRightAside.vue";

export default {
  components: {
    "qgov-header": TheHeader,
    "qgov-leftnav": TheLeftNav,
    "qgov-footer": TheFooter,
    "qgov-right-aside": TheRightAside,
  },
  mounted() {
    document.title = 'Registry of Births, Deaths and Marriages - ' + this.$route.name;
  },
  watch: {
    '$route'() {      
      document.title = 'Registry of Births, Deaths and Marriages - ' + this.$route.name;
    }
  },
  created() {    
    document.body.classList.add("qg-no-print-link");
    document.body.id = "body";
  },
};
</script>

<style lang="scss">
  #reopening ul,li {
    list-style: none;
    padding: 0;
  }

  .stretchWidth {
    width: 100%;
  }

  .disc-list li {
    list-style: disc !important;
    display: revert !important;
    padding: 0;
  }

  .inner-list li {
    list-style: circle !important;
    display: revert !important;
    margin-left: 2em;
  }

  .status::before {
    font-size: 24px;
  }
  .status :first-child {
    display: inline;
  }
  .status.warn::before {
    content: "\f071";
    display: inline;
    font-size: 24px;
  }
  .status.info::before {
    content: "\f05a";
    display: inline;
    font-size: 24px;
  }  
  .status::before {
    font-family: FontAwesome;
    padding: 10px
  }
</style>

